import React from 'react';

export const WizardProgress = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Personal Details' },
    { number: 2, label: 'Course Details' },
    { number: 3, label: 'Document Upload' },
    { number: 4, label: 'Final Review' },
  ];

  return (
    <div className="wizard-progress">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className={`progress-step ${step.number < currentStep ? 'completed' : ''} ${step.number === currentStep ? 'active' : ''}`}>
            <div className="progress-circle">
              {step.number < currentStep ? '✓' : step.number}
            </div>
            <div className="progress-label">{step.label}</div>
          </div>
          {index < steps.length - 1 && (
            <div className={`progress-connector ${step.number < currentStep ? 'completed' : ''}`}></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export const WizardSection = ({ icon, title, subtitle, children }) => (
  <div className="wizard-section">
    <div className="section-header">
      <div className="section-icon">{icon}</div>
      <div className="section-title">
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
    </div>
    {children}
  </div>
);

export default WizardProgress;
